let rootURL = process.env.OP_DEV_CONFIG['service-url'].replace(/\/$/, '');
if ((rootURL == 'service.ellacard.com') && (location.host == 'ellacard.com'))
  // We have a specail CloudFront behavior set up for ellacard.com/external-redirect so we can take advantage of
  // caching
  rootURL = '';

function wrap(url) {
  return url && `${rootURL}/external-redirect?url=${url}`;
}

export { wrap };
